import { sample } from 'effector'
import {
  markEpisodeWatchedByUserFx,
  markEpisodeWatchedWithoutSeasonByUserFx,
  setContentWatched,
  updateWatchedVodFx,
} from '~/features/content-watched/model'
import {
  removeFromContinueWatching,
  removeFromContinueWatchingFailed,
} from '~/features/remove-from-continue-watching/model'
import { $structure } from '../components/model'
import {
  applyContentWatchedToStructure,
  markContinueWatchingRowDirty,
  removeContinueWatchingItemFromStructure,
} from './structure'

sample({
  clock: removeFromContinueWatching,
  source: $structure,
  filter: Boolean,
  fn: (structure, command) =>
    removeContinueWatchingItemFromStructure(structure!, command),
  target: $structure,
})

sample({
  clock: setContentWatched,
  source: $structure,
  filter: Boolean,
  fn: (structure, command) =>
    applyContentWatchedToStructure(structure!, command),
  target: $structure,
})

sample({
  clock: removeFromContinueWatchingFailed,
  source: $structure,
  filter: Boolean,
  fn: (structure) => markContinueWatchingRowDirty(structure!),
  target: $structure,
})

sample({
  clock: [
    updateWatchedVodFx.fail,
    markEpisodeWatchedByUserFx.fail,
    markEpisodeWatchedWithoutSeasonByUserFx.fail,
  ],
  source: $structure,
  filter: Boolean,
  fn: (structure) => markContinueWatchingRowDirty(structure!),
  target: $structure,
})
